import { useCallback, useEffect } from 'react';
import DiscardConfirmation, {
  useDiscardConfirmation,
} from 'components/DiscardConfirmation';
import { getText } from 'i18n/intl';
import FieldRelationsDrawer from 'pages/configuration/fieldRelations/FieldRelationsDrawer';
import { fetchFields } from 'slices/field.slice';
import {
  checkFieldRelationSaveDisabled,
  fetchFieldRelations,
} from 'slices/fieldRelation.slice';
import { fetchReservationTemplates } from 'slices/reservationTemplate.slice';
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
import FieldRelationList from './FieldRelationList';

const FieldRelationsPage = () => {
  const dispatch = useAppDispatch();
  const [
    openDiscardDialog,
    onCloseDiscardDialog,
    confirmFn,
    confirmDiscardChanged,
  ] = useDiscardConfirmation();

  useEffect(() => {
    dispatch(fetchFieldRelations());
    dispatch(fetchReservationTemplates());
    dispatch(fetchFields());
  }, [dispatch]);

  const confirmDiscardFieldRelationChanges = useCallback(
    (isFirstDrawer: boolean, actionFn: () => void) => {
      const isFieldRelationDisabled = dispatch(
        checkFieldRelationSaveDisabled(isFirstDrawer)
      );
      if (!isFieldRelationDisabled) {
        return confirmDiscardChanged(actionFn);
      }
      actionFn();
    },
    []
  );

  return (
    <DefaultContentLayout
      title={getText('system_field_relation_title')}
      subtitle={getText('system_field_relation_subtitle')}
    >
      <div className="inner-content--wrapper">
        <FieldRelationList
          confirmDiscardFieldRelationChanges={
            confirmDiscardFieldRelationChanges
          }
        />
        <FieldRelationsDrawer
          confirmDiscardFieldRelationChanges={
            confirmDiscardFieldRelationChanges
          }
        />
        <DiscardConfirmation
          open={openDiscardDialog}
          onClose={onCloseDiscardDialog}
          confirmFn={confirmFn}
        />
      </div>
    </DefaultContentLayout>
  );
};

export default FieldRelationsPage;
